import BaseModal from "../BaseModal/BaseModal";
import {useEffect, useState} from "react";
import axiosInstance from "../../API/Axios/AxiosConfig";
import URLS from "../../API/Axios/URLS";
import {toast} from "react-toastify";

export default function ViewCouponCodeModal({
                                                className, isOpen,
                                                email, coupon_id,
                                                paymentIntent,
                                                setOpen, ...props
                                            }) {
    const [loading, setLoading] = useState(false);
    const [failed, setFailed] = useState(false);
    const [coupon, setCoupon] = useState(null);

    useEffect(() => {
        if (!isOpen) return;
        setLoading(true)
        axiosInstance.get(URLS.GetCouponCode + `/${paymentIntent}/${email}/${coupon_id}`).then((res) => {
            setCoupon(res.data?.coupon)
        }).catch((err) => {
            setFailed(true)
        }).finally(() => {
            setLoading(false)
        })
    }, [isOpen])

    return (
        <BaseModal innerClassName={"lg:w-1/3 overflow-auto"} isBoxOpen={isOpen} autoClose={false} defaultHeader={true}
                   title={"Coupon Code"}
                   setIsBoxOpen={setOpen}>
            <div className={"p-4 flex justify-center gap-3 items-center flex-col"}>
                {
                    loading ? (
                        <>
                            <p className={"text-xl text-center font-semibold"}>
                                Please wait while we retrieve your coupon code
                            </p>


                        </>
                    ) : failed ? (
                        <>
                            <p className={"text-2xl font-semibold"}>
                                Failed to fetch coupon code
                            </p>
                            <p>
                                Please try again later
                            </p>
                        </>
                    ) : (
                        <>
                            <p className={"text-2xl font-semibold"}>
                                Here is your coupon code
                            </p>
                            <p className={"text-2xl font-semibold"}>
                                <p
                                    onClick={() => {
                                        navigator.clipboard.writeText(coupon).then(() => {
                                            toast.info("Coupon code copied to clipboard")
                                        })
                                    }}
                                    className={"px-7 py-1 text-center cursor-pointer rounded-md mt-2 font-semibold text-2xl text-white bg-secondary-800"}>
                                    {coupon}
                                </p>
                            </p>
                            {/*<p className={""}>*/}
                            {/*    You have <b>21 days</b> from today to redeem this code, After 21 days, it will expire*/}
                            {/*    and can't*/}
                            {/*    be extended.*/}
                            {/*</p>*/}
                            <a
                                href={"https://www.detstudy.com/blogs/How%20To%20Use%20Your%20Coupon%20Code%20on%20the%20Duolingo%20English%20Test"}
                                target={"_blank"}
                                className={"text-blue-600 text-xl underline self-start"}
                            >
                                How to Use Your Coupon Code?
                            </a>
                        </>
                    )
                }
            </div>
        </BaseModal>

    )
}